export const ALL_VALUES = "all_values";

export interface IFilterDataItem {
  label: string;
  value: string;
}

// All values for different filters
export const allValues: IFilterDataItem = {
  label: "All",
  value: ALL_VALUES
};
